import create from 'zustand';
import produce from 'immer';
import { identity, pickBy } from 'lodash';

// Create request parameters based on search data
const createParameters = (search) => pickBy({
	type: 'subject:students',
	'name|surname:likeLower': `%${search.name}%`,
	// page: search.page
}, identity);

// Initial search data
const SEARCH_INITIAL = {
	name: '',
	// page: 1
};

// Initial store state
const SUBJECT_STUDENT_INITIAL = {
	// Search parameters
	search: SEARCH_INITIAL,

	// Request parameters
	parameters: createParameters(SEARCH_INITIAL),

	// Modals visiblity
	modal: false,

	// Mark addition
	data: {
		mark: '',
		type: ''
	},

	// Collected students
	students: []
};

export const useSubjectStudentStore = create(set => ({
	...SUBJECT_STUDENT_INITIAL,

	// Handle modal's visibility
	onModal: () => set(produce(state => {
		state.modal = !state.modal;
	})),

	// Handle search data change
	onSearch: ({ name, value }) => set(produce(state => {
		state.search[name] = value;
		// if (name !== 'page') state.search.page = 1;
		state.parameters = createParameters(state.search);
	})),

	// Handle data change
	onChange: ({ name, value }) => set(produce(state => {
		state.data[name] = value;
	})),

	// Handle mark addition
	onAdd: (mark) => set(produce(state => {
		const student = state.students.find(student => student.id === mark.studentId) ?? {};
		const grade = student.grades.find(grade => grade.id === mark.gradeId) ?? {};
		if (grade) grade.marks?.push(mark);
	})),

	// Handle mark update
	onUpdate: (updated) => set(produce(state => {
		const student = state.students.find(student => student.id === updated.studentId) ?? {};
		const grade = student.grades.find(grade => grade.id === updated.gradeId) ?? {};
		const current = grade.marks.find(mark => mark.id === updated.id) ?? {};

		current.mark = updated.mark;
		current.type = updated.type;
	})),

	// Handle mark remove
	onRemove: (removed) => set(produce(state => {
		const student = state.students.find(student => student.id === removed.studentId) ?? {};
		const grade = student.grades.find(grade => grade.id === removed.gradeId) ?? {};
		grade.marks = grade.marks.filter(mark => mark.id !== removed.id);
	})),

	// Initialize collected data
	onInit: (students) => set(produce(state => {
		state.students = students ?? [];
	})),

	// Reset store to initial state
	onReset: () => set({
		...SUBJECT_STUDENT_INITIAL
	})
}));